const useBlurOnClick = (e: React.MouseEvent<HTMLElement, MouseEvent>): void =>
  (e.target as HTMLAnchorElement).blur();

export default useBlurOnClick;
